// Product search events
export const productSearchStart = 'productSearch.start';
export const productSearchResult = 'productSearch.result';
export const productSearchSelect = 'productSearch.select';
// Order (New Contract) events
export const orderStepperEnter = 'order.enter';
export const orderStepChange = 'order.step.change';
export const orderStepCustomerAccountSelectionSubmit = 'order.step.customerAccountSelection.submit';
export const orderStepPersonalDataSubmit = 'order.step.personalData.submit';
export const orderStepDeliveryAddressSubmit = 'order.step.deliveryAddress.submit';
export const orderStepSupplyConnectionSubmit = 'order.step.supplyConnection.submit';
export const orderStepPaymentMethodSubmit = 'order.step.paymentMethod.submit';
export const orderStepApprovalFlagsSubmit = 'order.step.approvalFlags.submit';
export const orderSubmit = 'order.submit';
export const orderToChangeRate = 'order.toChangeRate';
export const orderBackToSelection = 'order.backToSelection';
// Change Rate events
export const changeRateStepperEnter = 'changeRate.enter';
export const changeRateStepChange = 'changeRate.step.change';
export const changeRateStepDeliveryDateSubmit = 'changeRate.step.deliveryDate.submit';
export const changeRateStepApprovalFlagsSubmit = 'changeRate.step.approvalFlags.submit';
export const changeRateSubmit = 'changeRate.submit';
export const changeRateBackToSelection = 'changeRate.backToSelection';
export const changeRateBackToNewContract = 'changeRate.backToNewContract';
//# sourceMappingURL=eventNames.js.map